import * as Sentry from "@sentry/browser";
import LogRocket from "logrocket";
import setupLogRocketReact from "logrocket-react";

import config from "../config";
import { checkCookieExistence } from "./cookie";
import { SegmentAnalytics } from "./googleAnalytics";

interface CurrentUser {
  id: string;
  email: string;
  phoneNumber?: string | null;
  fullName: string;
  createdAt: string;
  organization: {
    freemium: boolean;
  };
}

let initialized = false;

export const initLogrocket = (): void => {
  document.addEventListener(
    "mousemove",
    (): void => {
      const isImpersonating = checkCookieExistence("is_impersonating");
      if (config.appEnv === "production" && !initialized && !isImpersonating) {
        initialized = true;
        // cspell:disable-next-line
        LogRocket.init("otjbrk/brighthire-production", {
          release: config.appVersion,
          dom: {
            inputSanitizer: true,
          },
          network: {
            responseSanitizer: (response) => {
              if (typeof response.body !== "string") return response;
              try {
                const body = JSON.parse(response.body);
                if (body?.data?.searchApplicationAndApiKey?.searchApiKey) {
                  body.data.searchApplicationAndApiKey.searchApiKey =
                    "**redacted**";
                  return { ...response, body: JSON.stringify(body) };
                }
              } catch {
                // not JSON, pass through
              }
              return response;
            },
          },
        });
        setupLogRocketReact(LogRocket);
        LogRocket.getSessionURL((sessionURL) => {
          // Sentry
          Sentry.configureScope((scope) => {
            scope.setExtra("sessionURL", sessionURL);
          });
          SegmentAnalytics.track("LogRocket", {
            sessionURL,
          });
        });
      }
    },
    { once: true }
  );
};

export const identifyLogrocket = (currentUser?: CurrentUser): void => {
  const isImpersonating = checkCookieExistence("is_impersonating");
  if (
    config.appEnv === "production" &&
    currentUser &&
    initialized &&
    !isImpersonating
  ) {
    LogRocket.identify(currentUser.id, {
      email: currentUser.email,
      phone: currentUser.phoneNumber ?? "",
      fullName: currentUser.fullName,
      createdAt: currentUser.createdAt,
      freemium: currentUser.organization.freemium,
    });
  }
};
